import { createContext, useContext } from 'react';

interface AuthState {
  user: { name: string; email: string };
  roles: string[];
  refreshToken: () => Promise<void>;
}

const AuthContext = createContext<AuthState | null>(null);

export function AuthProvider({
  children,
  user,
  roles,
  refreshToken,
}: AuthState & { children: React.ReactNode }) {
  return (
    <AuthContext.Provider value={{ user, roles, refreshToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');

  return {
    userName: ctx.user.name,
    userEmail: ctx.user.email,
    roles: ctx.roles,
    isComplianceOfficer: ctx.roles.some(r => r.toLowerCase() === 'complianceofficer' || r.toLowerCase() === 'compliance'),
    refreshToken: ctx.refreshToken,
  };
}
